import { PathsManifest } from '@zg-rentals/paths-manifest';

const getAllPaths = (brand: string) => {
  const pathsManifest = new PathsManifest('/rental-manager', brand);

  return pathsManifest.getAllPaths();
};

// update with any new path patterns that need to be supported
// currently all pages with propertyId parameter have propertyId preceded by 'properties/' in the url
const LISTING_ALIAS_PATH_PREFIX_DELIMETERS = ['properties/'];

const formatUrl = (url: string) => `/rental-manager/${url}`;

const RMW_PATH = {
  PREMIUM_ANALYTICS: 'premium-analytics',
  LISTING_CLAIMING: formatUrl('listing-claiming'),
  IP_CHECK_PAGE: '/rental-manager/ip',
  LISTING_CLAIMING_HELP: '/corp/Terms.htm', // @TODO fix once we know the url
};

const getGenericApplicationUrl = (host: string, listingAlias: string) => {
  return `https://${host}/renter-hub/applications/listing/${listingAlias}/rental-application?utm_source=sohapplicationshare&utm_medium=desktopmweb&utm_campaign=applicationlinkshare`;
};

export { LISTING_ALIAS_PATH_PREFIX_DELIMETERS, RMW_PATH };

export default {
  getAllPaths,
  getGenericApplicationUrl,
};
